import React from 'react';
import { withRouter } from 'react-router-dom'

import ReactGA from 'react-ga';

class Analytics extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      renderable: false,
      random: Math.floor(Math.random() * 1000000)
    }
  }
  
  trackView() {
    this.setState({
      random: Math.floor(Math.random() * 1000000),
      renderable: true
    }, () => {
      ReactGA.pageview(this.props.location.pathname + this.props.location.search);
    });

    //this.trackConversion();

    /*if (process.env.NODE_ENV !== "development") {
      ReactGA.pageview(this.props.location.pathname + this.props.location.search);
    } else {
      console.log("Tracked Pageview")
    }*/
  }

  trackError(message) {
    ReactGA.exception({
      description: message,
      fatal: true
    });
  }

  onCustomTracking(e) {
    switch (e.detail.type) {
      case "error":
        this.trackError(e.detail.description);
        break;
      default:
        break;
    }
  }

  componentDidMount() {
    ReactGA.initialize(process.env.REACT_APP_GA_ID, {
      debug: process.env.NODE_ENV === "development",
      testMode: process.env.NODE_ENV === "development",
      gaOptions: {
        anonymizeIp: true
      }
    });

    this.trackView();

    window.addEventListener('trackCustomEvent', this.onCustomTracking.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('trackCustomEvent', this.onCustomTracking.bind(this));
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.random !== this.state.random) {
      return;
    }
    
    this.trackView();
  }

  render() {
    const { renderable, random } = this.state;

    return (
      <>
        {renderable && <img key={"tpx" + random} src={`https://t.simply-hentai.com/t.png?r=${random}&index=${process.env.REACT_APP_LOGO}`} id={"tpx"} style={{ position:"absolute", left: "-9999px" }} alt={""} />}
      </>
    );
  }
}

export default withRouter(Analytics);